export default __webpack_public_path__ + "static/media/arrow_top_bold.278f2709.svg";